import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/lib/i18n";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("fl_lang") || "ar");

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    localStorage.setItem("fl_lang", lang);
  }, [lang]);

  const t = dict[lang];
  const dir = lang === "ar" ? "rtl" : "ltr";
  const isRTL = lang === "ar";
  return (
    <LangCtx.Provider value={{ lang, setLang: setLangState, t, dir, isRTL }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
